import { range, take } from 'lodash'

export default {
  displayCount: 7,

  pages (active: number, total: number) {
    if (total <= 0) return []

    const lastStart = Math.max(total - this.displayCount + 1, 1)
    const start = Math.min(Math.max(active, 1), lastStart)
    const pages = range(start, total + 1)
    return take(pages, this.displayCount)
  },

  navigationNumbers (active: number, total: number) {
    return {
      get next () {
        const next = active + 1
        return next > total ? total : next
      },
      get previous () {
        const previous = active - 1
        return previous < 1 ? 1 : previous
      }
    }
  }
}
